import axiosApi from "../.././../components/Api/Axios";
import BackendServices from "../../../components/Api/BackendService";
import { details as detailsPath } from "../../../components/Paths/paths";
import VerifyDetailsView from "../../../Models/Verify/Models/VerifyAuditDetailsView";
import useGetVerifyAudit from "../VerifyAuditDetails/util/useGetVerifyAudit";
import VerifyAuditDetailsPage from "../VerifyAuditDetails";
import { trackEvent } from "../../../util/googletagmanager/GTM";
import { getUserId, isMegatronLiteUser, isMegatronProUser } from "../../../Authentication/Auth";

export default (id: string | number): () => void =>{
   const megatronProUser = getUserId() != undefined &&  isMegatronProUser() ;
      const megatronLiteUser = getUserId() != undefined && isMegatronLiteUser();
        
    return () => {
    if(megatronLiteUser || megatronProUser ){
        trackEvent('Feature_Interaction',{
            User_Role:megatronLiteUser?"Company user Lite":megatronProUser?"Company user Pro":"Other User",
            Tab_Section:"Certificate Tracker-Detailed Page",
            Type:"Button",
            Feature_Function:"Favourite Audit (Menu option)",
            UserInput:"Click"})
        }
      
        axiosApi.post(
            `${BackendServices.AUDIT_SERVICE.VERIFY}/detailFavouriteUpdate/${id}`
          ).then(response => {     
      window.location.reload();
    });
  }
};
  